// Eager slim slice of the mail function barrel.
//
// Mail is a lazy sub-app (see components/eagerSlice.js): the /mail route and
// the header envelope fold the FULL mail context on demand. Only the
// functions non-mail surfaces reach BEFORE any fold stay here:
//   • toggleMailDrawer / openMailDrawer / closeMailDrawer — el.call'd by the
//     shell (the console fallback, future deep-links and toast actions) on
//     ANY route; opening ensures the fold itself, like chat's
//     openChatFromToast.
// Every OTHER mail function registers at fold time.
//
// Mail's state.js ALSO rides the eager entry in sharedLibraries.js — every
// `mail*` key and `_mailDrawerOpen` are declared ONLY there, and the header
// flips `_mailDrawerOpen` on any route (v3.14 trips on undeclared root keys).
export * from './drawer.js'
// The setup gate + the account writes ride the eager slice for the same reason
// their components do (components/eagerSlice.js): MailSetupPanel paints inside
// the header drawer and on /settings, both of which are reached before — or
// without — the /mail route's fold.
export * from './setup.js'
export * from './accounts.js'
// The step card and the setup notice resolve their copy through these on the
// same routes (CORE-MAIL-SETUP-STEPS-AND-ERRORS-NEED-I18N-CODES-1): a lazy
// resolver would leave the drawer's steps and the /settings notice painting
// nothing before the fold.
export * from './serverCopy.js'
// The SSE stream is eager because the UNREAD BADGE is a header/navbar surface
// on EVERY route (§3.6), and the stream's `mail.snapshot` frame is the only
// producer of the count it reads. Lazy, the badge could not light until the
// viewer opened the drawer or /mail — which is the one moment a badge is no
// longer needed. Same correction chat's realtime already carries in the shell
// ("previously the SSE stream only opened once /chat was visited",
// workspace/app.js). The shell boots it flag-gated; the module adds no new
// heavy dependency (mailUtils is already eager through Sidebar.js).
export * from './subscribeMailStream.js'
// The compose lifecycle is eager because five of its six §3.2a entry points
// fire on routes where the fold has not happened: the drawer Compose button,
// the person card Email action, the mailto interception, the assistant tool,
// and the undo toast's `undoMailSend` action. Attachment staging stays lazy —
// its only caller is the dock, which mounts post-fold on /mail.
export * from './compose.js'
// The AI-answer view's PROVIDER (functions/mailAnswer.js): the shell reads it
// on ANY route to know the mail view exists (gated by the /mail page, the
// dark-by-default `mail` flag), before the mail context folds; the view
// itself folds it first (`fold: 'mail'`, workspace functions/
// assistantAppViews.js).
export { mailAiViews } from './mailAnswer.js'
